/**
 * @file tags.api.js
 * @module TagsAPI
 * @description HTTP API wrapper for tag-related endpoints. Methods return Axios promises.
 */

import { axiosInstance } from "./axios";

export const TagsAPI = {
    /**
     * Retrieve tags with pagination and optional query.
     * @param {number} limit - Number of items per page.
     * @param {number} page - Page number.
     * @param {string} [query=""] - Optional query string for filtering.
     * @param {string} [token=""] - Optional authentication token.
     * @returns {Promise} Axios promise resolving to tags list.
     */
    getTags: async (limit, page, query = "", token = "") => {
        return axiosInstance(token).get(`/tags?limit=${limit}&page=${page}${query ? `&${query}` : ""}`);
    },

    /**
     * Create a new tag.
     * @param {Object} payload - Tag payload.
     * @param {string} [token=""] - Optional authentication token.
     * @returns {Promise} Axios promise resolving to created tag.
     */
    createTags: (payload, token = "") => {
        return axiosInstance(token).post(`/tags`, payload);
    },

    /**
     * Get a tag by id.
     * @param {string} tagId - Tag identifier.
     * @param {string} [token=""] - Optional authentication token.
     * @returns {Promise} Axios promise resolving to tag data.
     */
    getTagById: (tagId, token = "") => {
        return axiosInstance(token).get(`/tags/${tagId}`);
    },

    /**
     * Delete a tag by id.
     * @param {string} tagId - Tag identifier.
     * @param {string} [token=""] - Optional authentication token.
     * @returns {Promise} Axios promise indicating deletion result.
     */
    deleteTagById: (tagId, token = "") => {
        return axiosInstance(token).delete(`/tags/${tagId}`);
    },

    /**
     * Get tags options for select inputs.
     * @param {string} [token=""] - Optional authentication token.
     * @returns {Promise} Axios promise resolving to options list.
     */
    getTagsOptions: (token = "") => {
        return axiosInstance(token).get(`/tags-options`);
    }
}
